<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="queryParams" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <!-- 查询--->
              <el-form-item label="商家账号："  prop="operNo">
                <el-input size="small" v-model="queryParams.operNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="统计时间：" prop="time">
                <el-date-picker
                  size="small"
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="btn-bar-right">
              <el-button type="primary" size="small" @click="loadData"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <el-table border :data="tableData">
        <el-table-column label="商家账号" prop="userName"></el-table-column>
        <el-table-column label="设计数量" prop="cpsl"></el-table-column>
        <el-table-column label="订单数量" prop="xdbs"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  listRecharge,
  updateRecharge,
  listInvite,
} from "@/api/business/fundManage"
import noImage from "@/assets/images/no_image.png"
import { listUser } from "@/api/business/merchantManage"
import { getInviterMerchantStat } from "@/api/customProduct/product"

export default {
  components: { Breadcrumb },
  data() {
    return {
      queryParams: {
        operNo: undefined,
        time: [],
        beginTime: undefined,
        endTime: undefined,
        pageSize: 30,
        pageNum: 1,
      },
      total: 0,
      loading: false,
      noImage: noImage,
      tableData: [],
      closeDelay: 0,
      currentRow: {},
      auditBtnShow: false,
      detailForm: {},
      dialogVisible: false,
      detailFormRules: {
        checkStatus: [
          { required: true, message: "请选择审核结果！", trigger: "blur" },
        ],
      },
      userList: [],
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "nginx"]),
    role() {
      return this.$store.state.user.roles[0]
    },
  },
  mounted() {
    this.loadData()
    this.getUserList()
  },
  methods: {
    async getUserList() {
      let result = await listUser({
        pageNum: 1,
        pageSize: 100000,
        userType: "01",
      })
      this.userList = result.rows
    },
    /* 获取列表数据 */
    loadData() {
      let _self = this
      this.startLoading()
      _self.queryParams.beginTime = _self.queryParams.time[0]
      _self.queryParams.endTime = _self.queryParams.time[1]
      let params = Object.assign({}, _self.queryParams)
      delete params["time"]
      let loadMethod = getInviterMerchantStat
      loadMethod(params)
        .then((res) => {
          _self.tableData = res.data
          this.endLoading()
        })
        .catch((err) => {
          console.error(err)
          this.endLoading()
        })
    },
    resetForm() {
      this.$refs["form"].resetFields()
    },
    handleCurrentChange(val) {
      this.currentRow = val
      if (this.currentRow && this.currentRow.checkStatus === "01") {
        this.auditBtnShow = true
      } else {
        this.auditBtnShow = false
      }
    },
    handleOpenAudit(row) {
      this.detailForm = Object.assign({}, row)
      this.detailForm.checkStatus = "02"
      this.dialogVisible = true
    },
    handleAudit() {
      let _self = this
      this.$refs["detailForm"].validate((valid) => {
        if (valid) {
          if (
            _self.detailForm.checkStatus == "03" &&
            (_self.detailForm.auditOpinion == null ||
              _self.detailForm.auditOpinion.trim() == "")
          ) {
            _self.$message.error("请填写审核意见")
            return
          }
          updateRecharge(_self.detailForm).then((response) => {
            if (response.code == "200") {
              _self.$message.success("审核成功！")
              _self.dialogVisible = false
              _self.loadData()
            } else {
              _self.$message.error("审核失败！")
            }
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
</style>
